import React, { useState } from "react";
import { Select, SelectItem } from "@heroui/react";

export default function PreferencesView({ data }) {
  const [type, setType] = useState("ev_news");
  const [order, setOrder] = useState("high_to_low");

  const alertLabels = {
    ev_news: "EV News & Policy",
    new_launches: "New Launches",
    offers_discounts: "Offers & Discounts",
    upcoming_vehicles: "Upcoming Vehicles",
  };

  const result = data[type]?.result || {};

  const getSorted = () => {
    let list = [];
    switch (type) {
      case "ev_news":
        return result;
      case "new_launches":
        list.push(
          ...(result.company || []).map((c) => ({
            title: `Company: ${c.name}`,
            count: c.count,
          }))
        );
        if (result.all_companies?.[0]?.count)
          list.push({
            title: "All Companies (New Launch)",
            count: result.all_companies[0].count,
          });
        break;
      case "offers_discounts":
        if (result.all_companies?.[0]?.count)
          list.push({
            title: "All Companies (Offers)",
            count: result.all_companies[0].count,
          });
        if (result.all_vehicles?.[0]?.count)
          list.push({
            title: "All Vehicles (Offers)",
            count: result.all_vehicles[0].count,
          });
        break;
      case "upcoming_vehicles":
        if (result.enabled)
          list.push({ title: "All Upcoming Vehicles", count: result.enabled });
        break;
      default:
        break;
    }
    return list.sort((a, b) =>
      order === "high_to_low" ? b.count - a.count : a.count - b.count
    );
  };

  const list = getSorted();

  return (
    <>
      {/* Filters */}
      <div className="mb-4 p-4 bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col md:flex-row gap-4 justify-between">
        {/* <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="w-full md:w-1/3 p-2 border border-gray-300 rounded-md bg-white focus:ring-[#FDBF00] focus:border-[#FDBF00] transition"
        >
          {Object.keys(alertLabels).map((key) => (
            <option key={key} value={key}>
              {alertLabels[key]}
            </option>
          ))}
        </select> */}
        <div className="w-full md:w-1/3">
         <Select
            placeholder="Select Type"
            selectedKeys={new Set([type])}
            onSelectionChange={(keys) => setType(Array.from(keys)[0])}
            classNames={{
              trigger:
                "border border-gray-300 rounded-md bg-white focus:ring-[#FDBF00] focus:border-[#FDBF00] transition",
            }}
          >
            {Object.keys(alertLabels).map((key) => (
              <SelectItem key={key}>{alertLabels[key]}</SelectItem>
            ))}
          </Select>
          </div>
        {/* <select
          value={order}
          onChange={(e) => setOrder(e.target.value)}
          className="w-full md:w-1/3 p-2 border border-gray-300 rounded-md bg-white focus:ring-[#FDBF00] focus:border-[#FDBF00] transition"
        >
          <option value="high_to_low">Sort: High → Low</option>
          <option value="low_to_high">Sort: Low → High</option>
        </select> */}
        <div className="w-full md:w-1/5">
         <Select
            placeholder="Sort Order"
            selectedKeys={new Set([order])}
            onSelectionChange={(keys) => setOrder(Array.from(keys)[0])}
            classNames={{
              trigger:
                "border border-gray-300 rounded-md bg-white focus:ring-[#FDBF00] focus:border-[#FDBF00] transition",
            }}
          >
            <SelectItem key="high_to_low">Sort: High → Low</SelectItem>
            <SelectItem key="low_to_high">Sort: Low → High</SelectItem>
          </Select>
          </div>
      </div>

      {/* Data */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          User Preferences for '{alertLabels[type]}'
        </h3>

        {type === "ev_news" || type === "new_launches" ? (
          <div className="space-y-6">
            {/* General */}
            {type === "ev_news" && (
              <Section
                title="General"
                items={[
                  {
                    label: "General News & Policy",
                    count: result.general?.[0]?.count || 0,
                  },
                ]}
              />
            )}
            {/* Vehicle */}
            <Section
              title="Vehicle Specific"
              all={{
                label: "All Vehicles",
                count: result.all_vehicles?.[0]?.count || 0,
              }}
              list={result.vehicle || []}
              order={order}
            />
            {/* Company */}
            <Section
              title="Company Specific"
              all={{
                label: "All Companies",
                count: result.all_companies?.[0]?.count || 0,
              }}
              list={result.company || []}
              order={order}
            />
          </div>
        ) : list.length > 0 ? (
          <ul className="space-y-3">
            {list.map((i, idx) => (
              <li
                key={idx}
                className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200"
              >
                <p className="text-gray-800">{i.title}</p>
                <span className="font-semibold text-gray-900 bg-gray-100 px-3 py-1 rounded-full text-sm">
                  {i.count.toLocaleString()} users
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500">
            No preference data available for this category.
          </p>
        )}
      </div>
    </>
  );
}

function Section({ title, all, list = [], order = "high_to_low", items = [] }) {
  const sorted = [...list].sort((a, b) =>
    order === "high_to_low" ? b.count - a.count : a.count - b.count
  );
  return (
    <div>
      <h4 className="font-semibold text-lg text-gray-700 mb-2 pb-2 border-b">
        {title}
      </h4>
      <ul className="space-y-3 pt-2">
        {items.map((i, idx) => (
          <li
            key={`item-${idx}`}
            className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200"
          >
            <p className="text-gray-800">{i.label}</p>
            <span className="font-semibold text-gray-900 bg-gray-100 px-3 py-1 rounded-full text-sm">
              {i.count.toLocaleString()} users
            </span>
          </li>
        ))}
        {all && (
          <li className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-gray-800">{all.label}</p>
            <span className="font-semibold text-gray-900 bg-gray-100 px-3 py-1 rounded-full text-sm">
              {all.count.toLocaleString()} users
            </span>
          </li>
        )}
        {sorted.map((v, i) => (
          <li
            key={`v-${i}`}
            className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200"
          >
            <p className="text-gray-800">{v.name}</p>
            <span className="font-semibold text-gray-900 bg-gray-100 px-3 py-1 rounded-full text-sm">
              {v.count.toLocaleString()} users
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
